import {
  IPackageMethod,
  ITabGame,
  ITopupGame,
  ITopupGameDetail,
  ITopupPackage,
  ITopupSelectedData,
  OnePackage,
  OnePackageGlobal
} from "@/app/interfaces/ITopup"
import { FC, useContext, useEffect, useMemo, useState } from "react"
import { ConfirmIdStep } from "./detail/ConfirmIdStep"
import { SecondStep } from "./detail/SecondStep"
import { TopupDetailTab } from "./detail/TopupDetailTab"
import { TOPUP_STEP } from "./topup.constant"
import { useRouter } from "next/router"
import HeaderCustomMobile from "@/app/components/header-custom-mb"
import { useTranslation } from "next-i18next"
import { UserService } from "@/app/services/services"
import ImageLa from "public/img/store/icon_la.png"
import { AppContext } from "@/app/context"
import { useQueryGetListTopup } from "@/app/services/query-fn/topup"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/app/components/ui/select"
import Link from "next/link"
import { isClient, OPEN_MODAL, QUERY_KEY } from "@/app/configs"
import { useQueryGetListGameBanner } from "@/app/services/query-fn/game"
import { IBannerGame } from "@/app/interfaces"
import { UpdatePhoneModal } from "./detail/UpdatePhoneModal"
import { useMutationLoginSDK } from "@/app/services/query-fn"
import { useQueryClient } from "@tanstack/react-query"

interface TopupProps {
  gameDetail: ITopupGameDetail
}

export const initSelectedData = {
  selectMethod: {} as IPackageMethod,
  selectUser: {
    user_id: "",
    username: ""
  },
  selectServer: {
    server_id: "",
    server_name: ""
  },
  selectRole: {
    role_id: "",
    role_name: ""
  },
  country_code: "",
  selectPlatform: {
    platform_id: "",
    platform_name: ""
  },
  selectPackage: {} as OnePackage,
  hoverDescription: ""
}

const GAME_ID_TIEU_NGAO = "GMA202306"

export const TopupContainer: FC<TopupProps> = ({ gameDetail }) => {
  const { userInfo, setOpenModal } = useContext(AppContext)
  const [step, setStep] = useState<number>(TOPUP_STEP.CONFIRM_ID)
  const router = useRouter()
  const { t } = useTranslation()
  const [selectedData, setSelectedData] =
    useState<ITopupSelectedData>(initSelectedData)
  const [sourcePackageAndTab, setSourcePackageAndTab] =
    useState<ITopupPackage>()
  const [selectedTab, setSelectedTab] = useState<ITabGame | undefined>(
    undefined
  )
  const [visible, setVisible] = useState(false)
  const {
    mutate: loginSDKFromGamotaId,
    isPending: isLoginSDKFromGamotaIdPending
  } = useMutationLoginSDK()
  const queryClient = useQueryClient()

  const { data: listGameBanner } = useQueryGetListGameBanner({
    type: "store"
  })
  const token = isClient ? window.localStorage.getItem("token") : ""

  const listNotPopup = useMemo(() => {
    if (!listGameBanner || !listGameBanner?.length) {
      return []
    }
    return listGameBanner?.filter((item: IBannerGame) => !item.open_popup)
  }, [listGameBanner])

  const { themeApp } = useContext(AppContext)
  const { data, isLoading } = useQueryGetListTopup()
  const [game, setGame] = useState<any | undefined>({
    game_id: "",
    game_name: "",
    icon: "",
    slug_name: router?.query?.slug_name
  })
  const [extendData, setExtendData] = useState<{
    alreadyGoldGift: number
    totalLimit: number
  }>()
  const [listPackageType, setListPackageType] = useState<"image" | "text">(
    "text"
  )

  useEffect(() => {
    if (data && data?.length > 0) {
      const _game: any = OptionGame?.find(
        (item: any) => item?.slug_name === router?.query?.slug_name
      )
      setGame(_game)
    }
  }, [data])

  const OptionGame = !!data ? data : []

  const onChangeGame = (value: string) => {
    const _game: any = OptionGame?.find((item: any) => item?.game_id === value)
    router.push({
      pathname: "/topup/[slug_name]",
      query: {
        slug_name: _game.slug_name
      }
    })

    setGame(_game)
  }

  const [loadingCallingMethod, setLoadingCallingMethod] =
    useState<boolean>(false)

  const handleSetExtendData = (value: {
    alreadyGoldGift: number
    totalLimit: number
  }) => {
    setExtendData(value)
  }

  const handleChangeSelectedTab = (tab: ITabGame) => {
    !loadingCallingMethod && setSelectedTab(tab)
  }

  const listStep = [
    {
      title: t("store.topup_confirm_id"),
      step: TOPUP_STEP.CONFIRM_ID
    },
    {
      title: t("topup.select_method"),
      step: TOPUP_STEP.PACKAGE_METHOD
    },
    {
      title: t("store.topup_payment"),
      step: TOPUP_STEP.CHECKOUT
    }
  ]

  const renderStep = useMemo(() => {
    switch (step) {
      case TOPUP_STEP.CONFIRM_ID:
        return (
          <ConfirmIdStep
            gameDetail={{
              ...gameDetail,
              user: {
                user_id: gameDetail?.last_transaction?.user_id || "",
                username: gameDetail?.last_transaction?.username || ""
              },
              servers: {}
            }}
            selectedData={selectedData}
            setSelectedData={setSelectedData}
            setSelectedTab={setSelectedTab}
            setSourcePackageAndTab={setSourcePackageAndTab}
            setStep={setStep}
            handleSetExtendData={handleSetExtendData}
            setListPackageType={setListPackageType}
          />
        )
      default:
        return sourcePackageAndTab ? (
          <SecondStep
            packageAndTab={sourcePackageAndTab}
            selectedTab={selectedTab}
            handleChangeSelectedTab={handleChangeSelectedTab}
            selectedData={selectedData}
            setSelectedData={setSelectedData}
            loading={loadingCallingMethod}
            setLoading={setLoadingCallingMethod}
            extendData={
              gameDetail?.game_id === GAME_ID_TIEU_NGAO ? extendData : null
            }
            listPackageType={listPackageType}
            gameDetail={gameDetail}
          />
        ) : null
    }
  }, [
    step,
    gameDetail,
    selectedData,
    sourcePackageAndTab,
    selectedTab,
    handleChangeSelectedTab,
    loadingCallingMethod,
    extendData
  ])

  const onClose = () => {
    if (window.history?.length && window.history.length > 1) {
      router.back()
    } else {
      router.push("/store")
    }
  }

  useEffect(() => {
    if (router.query.slug_name) {
      setSelectedData(initSelectedData)
      setStep(TOPUP_STEP.CONFIRM_ID)
      setSourcePackageAndTab(undefined)
      setSelectedTab(undefined)
      setExtendData(undefined)
    }
    if (router.query.slug_name === "napla") {
      setSelectedData({
        ...selectedData,
        selectUser: {
          user_id: userInfo?.userid,
          username: userInfo?.username
        },
        selectServer: {
          server_id: "napla",
          server_name: "napla"
        },
        selectRole: {
          role_id: "napla",
          role_name: "napla"
        }
      })
    }
  }, [router.query.slug_name, userInfo, gameDetail])

  const onLoginBySdk = (access_token?: string) => {
    if (!!access_token) {
      loginSDKFromGamotaId(
        {
          access_token: access_token
        },
        {
          onSuccess: (dataSuccess) => {
            const res = dataSuccess?.data?.data
            if (!!res?.access_token) {
              localStorage.setItem("token", res?.access_token)

              queryClient.invalidateQueries({
                queryKey: [QUERY_KEY.PROFILE_INFO],
                refetchType: "active"
              })

              router.push({
                pathname: router.pathname,
                query: {
                  slug_name: router.query.slug_name
                }
              })
            }
          },
          onError: (errorMessage: any) => {
            setOpenModal(OPEN_MODAL.LOGIN_MODAL)
            router.push({
              pathname: router.pathname,
              query: {
                slug_name: router.query.slug_name
              }
            })
          }
        }
      )
    }
  }

  useEffect(() => {
    if (router?.query?.update === "1") {
      UserService.getReloadProfile()
    }
  }, [router])

  useEffect(() => {
    if (userInfo?.id && !userInfo?.phone && router?.query?.update !== "1") {
      // setVisible(true)
    }
  }, [router?.query?.update, userInfo])

  useEffect(() => {
    if (!!router?.query?.access_token) {
      onLoginBySdk(router?.query?.access_token?.toString() || "")
    }
  }, [router?.query?.access_token])

  useEffect(() => {
    if (!token && !router.query.access_token) {
      setOpenModal(OPEN_MODAL.LOGIN_MODAL)
    }
  }, [setOpenModal, token, router])

  return (
    <>
      <HeaderCustomMobile
        isInpage
        heading={
          router.query?.slug_name === "napla"
            ? t("store.la_invoice")
            : listStep.find((item: any) => item?.step === step)?.title
        }
        action={onClose}
      />
      <div
        className={`max-w-[1280px] mx-auto min-h-[90dvh] md:min-h-0 flex flex-col ${
          router.query?.slug_name === "napla" ? "md:mt-[40px]" : "md:mt-[64px]"
        }`}
      >
        {!!listNotPopup?.length &&
          router.query?.slug_name !== "napla" &&
          step === TOPUP_STEP.CONFIRM_ID && (
            <div className="max-w-[500px] w-full mx-auto mb-6">
              <Link
                href={
                  listNotPopup[0]?.click_url
                    ? listNotPopup[0]?.click_url
                    : "/store"
                }
              >
                <img
                  src={listNotPopup[0]?.banner_app || listNotPopup[0]?.banner}
                  className="w-full aspect-[3/1] object-cover rounded-2xl"
                />
              </Link>
            </div>
          )}

        {router.query?.slug_name === "napla" ? (
          <div className="md:flex justify-between items-center mb-[24px] hidden">
            <div className="flex items-center bg-white border border-black/10 rounded-[12px] p-[8px] pr-[16px] dark:bg-white/10 dark:border-neutral-03">
              <img src={ImageLa.src} className="w-[32px] h-[32px] mr-[8px]" />
              <p className="text-[16p] Nunito-700">{t("store.la_invoice")}</p>
            </div>
            <div className="flex items-center">
              <img src={ImageLa.src} className="w-[20px] h-[20px] mr-[8px]" />
              <p className="text-[14px] Nunito-600 text-main-01 dark:text-main-disable">
                {userInfo?.total_la?.toLocaleString()}
              </p>
            </div>
          </div>
        ) : (
          <div className="flex max-w-[500px] w-full mx-auto justify-between items-center xs:mb-[24px] mb-[32px] gap-[16px]">
            <Select
              value={game?.game_id || ""}
              onValueChange={(value: string) => onChangeGame(value)}
            >
              <div className="relative xs:flex-1">
                <SelectTrigger
                  asChild={false}
                  className="px-[12px] xs:px-[6px] h-[64px] xs:h-[48px] border-stroke rounded-[12px] bg-white dark:bg-bg-disable/10 flex gap-[4px] items-center"
                >
                  <SelectValue placeholder={t("common.chose_game")}>
                    <div className="flex items-center flex-1 gap-4 xs:gap-2">
                      <img
                        src={game?.icon}
                        alt={game?.game_name}
                        className="w-[40px] h-[40px] xs:w-[30px] xs:h-[30px] rounded-[12px] xs:rounded-[8px]"
                      />
                      <div className="text-[16px] xs:text-[14px] line-clamp-1">
                        {game?.game_name || ""}
                      </div>
                    </div>
                  </SelectValue>
                  <svg width="24" height="24" viewBox="0 0 20 20" fill="none">
                    <path
                      d="M5.8335 8.3335L10.0002 11.6668L14.1668 8.3335"
                      stroke={themeApp === "dark" ? "#FAF8FF" : "#100D28"}
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </SelectTrigger>
              </div>

              <SelectContent align="end" className="p-1 rounded-[16px]">
                {OptionGame &&
                  [
                    ...OptionGame.sort((a, b) =>
                      a.game_name.localeCompare(b.game_name)
                    )
                  ]?.map((item: any) => (
                    <SelectItem
                      value={item?.game_id}
                      key={item?.game_id}
                      className="p-[6px] h-[36px] rounded-[12px] hover:!bg-bg-disable hover:!text-main-01 Nunito-500 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1]"
                    >
                      <div
                        className="flex items-center gap-[6px]"
                        title={item?.game_name}
                      >
                        {item?.icon && (
                          <img
                            src={item?.icon}
                            alt={item?.game_name}
                            className="w-[24px] h-[24px] rounded-[6px]"
                          />
                        )}
                        <p className="flex-1 line-clamp-1">{item?.game_name}</p>
                      </div>
                    </SelectItem>
                  ))}
              </SelectContent>
            </Select>
            <Link
              href={`/user/${
                userInfo?.alias ? userInfo?.alias : userInfo?.userid
              }?tab=transaction-manager&type=topup-all`}
              className="flex items-center gap-2 xs:gap-1"
            >
              <p className="text-[16px] Nunito-600 xs:text-[14px] text-main-01">
                {t("profile.transaction_history")}
              </p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
              >
                <path
                  d="M14 16.1L18 12.1M18 12.1L14 8.09998M18 12.1L6 12.1"
                  stroke="#3263E4"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          </div>
        )}
        <TopupDetailTab
          currentStep={step}
          selectedData={selectedData}
          listStep={listStep}
        />
        {renderStep}
        {visible && (
          <UpdatePhoneModal visible={visible} setVisible={setVisible} />
        )}
      </div>
    </>
  )
}
